import { motion } from "motion/react";
import { Button, Eyebrow } from "../components/Buttons";
import usePageMeta from "../usePageMeta";

export default function NotFound() {
  usePageMeta("Page not found — No. 1 Nails & Spa");
  return (
    <main className="section section--alt notfound">
      <motion.div className="container" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <Eyebrow>404</Eyebrow>
        <h1 className="hero__title">This page has <span className="editorial">wandered off</span></h1>
        <div className="hero__ctas">
          <Button to="/">Back to home</Button>
          <Button to="/booking" variant="blue-outline">Book online</Button>
        </div>
      </motion.div>
    </main>
  );
}
